import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import style from './style.module.scss';

import Switch from '@ontruck/ontruck-react-components/lib/Switch';

const Section = ({ children, className }) => (
  <div className={cx(style.section, className)}>{children}</div>
);

Section.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

const SectionTitle = ({ children, className }) => (
  <h2 className={cx(style.sectionTitle, className)}>{children}</h2>
);

SectionTitle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

const Row = ({ children, center, className }) => (
  <div
    className={cx(
      style.row,
      {
        [style.center]: center,
      },
      className
    )}
  >
    {children}
  </div>
);

Row.propTypes = {
  children: PropTypes.any,
  center: PropTypes.bool,
};

const Column = ({ children, third, half, twoThirds, className }) => (
  <div
    className={cx(
      style.column,
      {
        [style.third]: third,
        [style.half]: half,
        [style.twoThirds]: twoThirds,
      },
      className
    )}
  >
    {children}
  </div>
);

Column.propTypes = {
  children: PropTypes.any,
  third: PropTypes.bool,
  half: PropTypes.bool,
  twoThirds: PropTypes.bool,
  className: PropTypes.string,
};

const BlockSection = ({ title, labels, checked, onChange, disabled }) => {
  const blockClassName = cx(style.blockSection, {
    [style.blockSectionUnchecked]: !checked,
    [style.blockSectionChecked]: checked,
  });
  return (
    <Section className={blockClassName}>
      <SectionTitle>{title}</SectionTitle>
      <Row>
        <Column>
          <Switch
            checked={checked}
            onChange={onChange}
            preLabel={labels.enabled}
            switchClassName={style.blockedSwitch}
            switchCheckedClassName={style.blockedSwitchChecked}
            disabled={disabled}
          >
            <span>{labels.blocked}</span>
          </Switch>
        </Column>
      </Row>
    </Section>
  );
};

BlockSection.propTypes = {
  title: PropTypes.string.isRequired,
  labels: PropTypes.shape({
    enabled: PropTypes.string.isRequired,
    blocked: PropTypes.string.isRequired,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export { Section, SectionTitle, Row, Column, BlockSection };
